import api from "../../../../../api/api"


const getByPaymentVoucherId = (paymentVoucherId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher-payment-item/allocated/"+paymentVoucherId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getInvoiceSettlementList = (invoiceId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/invoice-settlement/list/"+invoiceId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getPurchaseVoucherList = (ledgerId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher-payment-item/purchase/"+ledgerId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getSalesVoucherList = (ledgerId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher-payment-item/sale/"+ledgerId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) => {
    return new Promise((resolve, reject) => {
        // Pointing to voucher-payment-item endpoint
        api.post("erp/voucher-payment-item", payload).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const remove = (id) => {
    return new Promise((resolve, reject) => {
        api.delete("erp/voucher-payment-item/" + id).then((res) => {
            if (!res.data.error) {
                resolve(res);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const voucherPaymentItemServices = {
    getByPaymentVoucherId,
    getPurchaseVoucherList,
    getSalesVoucherList,
    getInvoiceSettlementList,
    save,
    remove,
};

export default voucherPaymentItemServices;